import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
import { Router } from '@angular/router';
import { ArticleService } from '../../../../services/article.service';
import { CategorieService } from '../../../../services/categorie.service';
import { BPost, IBPost } from '../../../../models/b-post.model';
import Swal from 'sweetalert2';
import { BCategory } from '../../../../models/b-category.model';
import { UserService } from '../../../../services/user.service';
import { BComment } from '../../../../models/b-comment.model';
import {Clipboard} from "@angular/cdk/clipboard";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {
  @ViewChild('closebutton') closebutton;
  @ViewChild('closebutton1') closebutton1;
  articles = [];
  articlesTmp = [];
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  tableSizes: any = [10, 15, 30, 50];
  search: any;
  categories : [];
  perPage = 20;

  localStorage: Storage = localStorage;

  constructor(private articleService : ArticleService,
              private fb: FormBuilder, private authService: AuthService,private userService: UserService,
              private router: Router, private categorieService : CategorieService,
              private clipboard: Clipboard,
              private snackBar: MatSnackBar) { }

  ngOnInit(): void {
    this.authService.isAuthenticated().subscribe(isAuthenticated => {
      this.getAllArticles();
      this.loadCategories();
    },error=>{
      this.router.navigate(['/login']);
    });
  }

  loadCategories(){
    this.categorieService.getAllCategories().subscribe(rs=>{
      this.categories = rs;
    });
  }

  get f2() { return this.articleForm.controls; }

  articleForm = this.fb.group({
      //'title': ['', { validators: nameValidator('Le nom de l\'article', 2, 50), updateOn: 'change'}],
      'title': ['', Validators.required],
      'blogCategory': ['', Validators.required],
      'description': ['', Validators.required],
    }
  );

  model = {
    title: '',
    blogCategory: '',
    description: ''
  };

  selectCategorieArticle(value: any){
    this.articleService.getPublishArticleByCategory(value).subscribe(rs=>{
      this.articles = rs.content;
    });
  }

  getAllArticles(){
    this.articleService.getAllArticles().subscribe(rs=>{
      this.articles = rs.content;
      this.articlesTmp = rs;
      // console.log("Liste des articles");
      // console.log(rs);
    });
  }

  removeDuplicates<T>(list: T[], property: keyof T): T[] {
    const uniqueList: T[] = [];
    const uniqueValues = new Set<T[keyof T]>();

    for (const item of list) {
      const value = item[property];
      if (!uniqueValues.has(value)) {
        uniqueValues.add(value);
        uniqueList.push(item);
      }
    }

    return uniqueList;
  }

  publishArticle(article: BPost){
    Swal.fire({
      title: 'Voulez-vous vraiment publié cet article ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.articleService.publishArticle(article).subscribe(rs=> {
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Article publié avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadCategories();
            this.getAllArticles();
          }, error => {
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: 'Erreur lors de la publication de l\'article.',
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }
  comments: BComment[] = [];
  loadComments() {
    this.articleService.loadComment().subscribe(rs => {
      this.comments = rs;
      // console.log("~~~~~~~~~~~~~~~~~~~~~~~~");
      // console.log(this.comments);
    });
  }

  deleteComment(id: any) {
    Swal.fire({
      title: 'SUPPRESSION',
      text: 'Voulez-vous vraiment supprimer ce commentaire ?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'OUI',
      denyButtonText: `NON`,
    }).then((result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        this.articleService.deleteComment(id).subscribe(
        rs => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Commentaire supprimé avec succès"',
            showConfirmButton: false,
            timer: 2500
          });
          if(this.idArticle){
            this.onViewComment(this.idArticle);
          }
        }, error => {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: error.error.errorMessage,
            showConfirmButton: false,
            timer: 3000
          })
      });
      } else if (result.isDenied) {
        Swal.fire({
          icon: 'error',
          text: 'Suppression annulée',
        })
      }
    });
  }

  disableComment(b_comment: BComment) {
    b_comment.published = false;
    this.articleService.disableComment(b_comment).subscribe(rs => {
      // this.comments = [];
      this.comments = this.removeDuplicates(this.comments, "id");
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Le commentaire a bien été désactivé',
        showConfirmButton: false,
        timer: 1500
      });
      // this.loadComments();
    });
  }

  disableArticle(b_post: BPost) {
    b_post.published = false;
    this.articleService.disablePublishArticle(b_post).subscribe(rs => {
      this.articles = this.removeDuplicates(this.articles, "id");
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Article dépublié avec succès',
        showConfirmButton: false,
        timer: 1500
      });
      this.getAllArticles();
    });
  }

  currentArticle: BPost;
  onViewArticle(article: any) {
    this.articleService.getArticleById(article.id).subscribe(article =>  {
      this.currentArticle = article;
      // console.log("Détails article.....");
      // console.log(this.currentArticle);
    });
  }

  loadCom = false;
  idArticle : any;
  onViewComment(id: any){
    this.idArticle = id;
    this.articleService.allCommentsByPost(id).subscribe(rs =>  {
      this.comments = rs;
      this.comments = this.removeDuplicates(this.comments, "id");
      if(this.comments.length > 0){
        this.loadCom = true;
      }
      // console.log("Liste commentaires.....");
      // console.log(this.comments);
    });
  }

  activeComment(b_comment: any){
    // console.log(b_comment);
    this.articleService.publishComment(b_comment).subscribe(rs=>{
      this.comments = this.removeDuplicates(this.comments, "id");
      Swal.fire({
        position: 'top-end',
        icon: 'success',
        title: 'Le commentaire a bien été activé',
        showConfirmButton: false,
        timer: 1500
      });
      this.onViewComment(b_comment?.postId)
      this.close();
    })
  }

  updatedArticle: BPost;
  EditArticle = (article: BPost) => {
    this.updatedArticle = article;
    // console.log("Article à modifier...");
    // console.log(this.updatedArticle);
    this.articleForm.patchValue({
      title : article.title,
      blogCategory : article.blogCategory.id,
      description : article.description,
    })
  }

  onSubmit(){
    if(this.articleForm.valid){
      let article = new BPost();
      let category = new BCategory();
      const articleInfo1: BPost = this.articleForm.value;
      let test = articleInfo1.blogCategory;
      this.categorieService.getCategoryById(Number(test)).subscribe(rs=>{
        category.id = rs.id;
        category.name = rs.name;
        category.description = rs.description;
        article.title = this.model.title;
        article.blogCategory = category;
        article.description = this.model.description;
        this.articleService.saveArticle(article).subscribe(rs=>{
          this.reloadComponent();
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Article ajouté avec succés',
            showConfirmButton: false,
            timer: 2500
          });
          this.loadCategories();
          this.close();
        },error => {
          // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Erreur lors de d\'ajout de l\'article',
            showConfirmButton: false,
            timer: 1500
          });
        });
      });
    }
  }

  onSubmitEditForm(){
    let category = new BCategory();
    const articleInfo1: BPost = this.articleForm.value;
    let test = articleInfo1.blogCategory;
    this.categorieService.getCategoryById(Number(test)).subscribe(rs=>{
      category.id = rs.id;
      category.name = rs.name;
      category.description = rs.description;
      this.updatedArticle.title = articleInfo1.title;
      this.updatedArticle.blogCategory = category;
      this.updatedArticle.description = articleInfo1.description;
      // console.log("Article modified.....")
      // console.log(this.updatedArticle)
      this.userService.getByUSerName(this.updatedArticle.author).subscribe(user=>{
        this.updatedArticle.author = user;
        this.articleService.updateArticle(this.updatedArticle).subscribe(rs=>{
          // console.log("Article modifié ............");
          // console.log(rs);
          this.close1();
          this.reloadComponent();
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Article modifié avec succés',
            showConfirmButton: false,
            timer: 2500
          });
          this.loadCategories();
          this.close();
        },error => {
          // console.log(error);
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Erreur lors de de la modification de l\'article',
            showConfirmButton: false,
            timer: 1500
          });
        });
      });

    });
  }

  deleteArticle(post: IBPost){
    //console.log("Suppression d'un article")
    //console.log(post?.id);
    Swal.fire({
      title: 'Voulez-vous vraiment supprimer cet article ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonText: 'Non',
      confirmButtonText: 'Oui'
    }).then((result) => {
      if (result.isConfirmed) {
        this.articleService.deleteArticle(post.id).subscribe(
          rs=> {
            this.reloadComponent();
            Swal.fire({
              position: 'top-end',
              icon: 'success',
              title: 'Article supprimé avec succès.',
              showConfirmButton: false,
              timer: 1500
            });
            this.loadCategories();
          }, error => {
            // console.log(error);
            Swal.fire({
              position: 'top-end',
              icon: 'error',
              title: error.error.errorMessage,
              showConfirmButton: false,
              timer: 1500
            })
          }
        )
      }
    })
  }

  close() {
    this.closebutton.nativeElement.click();
  }

  close1() {
    this.closebutton1.nativeElement.click();
  }

  reloadComponent() {
    let currentUrl = this.router.url;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.router.navigate([currentUrl]);
  }

  copyLink(id: number) {
    //console.log(id);
    const environment = localStorage.getItem('env');
    //console.log(environment);

    let url: string = '';

    if(environment === 'dev'){
      url = `https://dev.kahpoo.com/#/b-post-details/${id}`;
    }else if(environment === 'recette'){
      url = `https://recette.kahpoo.com/#/b-post-details/${id}`
    }else if(environment === 'qualification'){
      url = `https://qualification.kahpoo.com/#/b-post-details/${id}`
    }else if(environment === 'production'){
      url = `https://www.kahpoo.com/#/b-post-details/${id}`
    }
    //console.log(url);

    const result: boolean = this.clipboard.copy(url);

    if(result){
      this.snackBar.open('Lien copié avec succès', undefined, {
        duration: 1000,
      });
    }else{
      this.snackBar.open('Lien non copié', undefined, {
        duration: 1000,
      })
    }
  }
}
